import axios from "axios";

const backendOverride = process.env.REACT_APP_BACKEND_URL?.trim().replace(/\/+$/, "");
const API = backendOverride ? `${backendOverride}/api` : "/api";

export const sendEnquiry = (payload) =>
  axios.post(`${API}/enquiries`, payload).then((r) => r.data);
